// extracted by mini-css-extract-plugin
export var container = "Expandable-module--container--37d13";
export var content = "Expandable-module--content--6d9bc";
export var expanded = "Expandable-module--expanded--6408b";
export var toggle = "Expandable-module--toggle--0f001";